module.exports = __webpack_public_path__ + "img/image11.5119f8c9.jpg";